import { render } from "./vueperslide.vue?vue&type=template&id=0e32166a&lang=pug"
import script from "./vueperslide.vue?vue&type=script&lang=js"
export * from "./vueperslide.vue?vue&type=script&lang=js"

import "./vueperslide.vue?vue&type=style&index=0&id=0e32166a&lang=scss"
script.render = render

export default script